import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 催促メール情報送信
 *
 * @export SendRemindMailInfoService
 * @class SendRemindMailInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SendRemindMailInfoService extends PlessJsonResponderSub<any> {
  private imageFileName: string;
  private remindMailTempId: string;
  private supplierAnnouncement: string;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof SendRemindMailInfoService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SendRemindMailInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageFileName: this.imageFileName,
        RemindMailTempId: this.remindMailTempId,
        SupplierAnnouncement: this.supplierAnnouncement
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof SendRemindMailInfoService
   */
  execute(imageFileName: string, remindMailTempId: string, supplierAnnouncement: string, successFunc: Function = null): void {
    this.imageFileName = imageFileName;
    this.remindMailTempId = remindMailTempId;
    this.supplierAnnouncement = supplierAnnouncement;
    this.successFunc = successFunc;
    this.send('sendRemindMailInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SendRemindMailInfoService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
